'use strict'

const OIDC = {
  ACTOR_TYPE_TRUSTED_PUBLISHER: 'trusted_publisher',
  ACTOR_TYPES: ['trusted_publisher'],
  ACTORS: {
    GITHUB: {
      ID: 'github',
      DISPLAY_NAME: 'GitHub Actions',
      EMAIL: 'npm-oidc-no-reply@github.com',
      // GitHub Actions has a static issuer URL
      ISSUER_URL: 'https://token.actions.githubusercontent.com',
      // https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderConfig
      OPENID_CONFIG_URL: 'https://token.actions.githubusercontent.com/.well-known/openid-configuration',
    },
    GITLAB: {
      ID: 'gitlab',
      DISPLAY_NAME: 'GitLab CI/CD',
      EMAIL: 'npm-oidc-no-reply@github.com',
      ISSUER_URL: 'https://gitlab.com',
      OPENID_CONFIG_URL: 'https://gitlab.com/.well-known/openid-configuration',
    },
  },
  // audience URL in OIDC IdP token
  IDP_TOKEN_AUDIENCE_URL_PRODUCTION: 'npm:registry.npmjs.org',
  IDP_TOKEN_AUDIENCE_URL_SANDBOX: 'npm:registry-sandbox.npm.red',
  // issuer URL of OIDC auth token is different for production and staging
  AUTH_TOKEN_ISSUER_URL_PRODUCTION: 'https://registry.npmjs.org',
  AUTH_TOKEN_ISSUER_URL_SANDBOX: 'https://registry-sandbox.npm.red',
}

module.exports = {
  OIDC,
}
